import { Component, Input, OnInit } from '@angular/core'
import { ResponseCode } from '@app/modules/shares/enum/common.enum'
import { ResponseModel } from '@app/service/api-response.model'
import { TranslateService } from '@ngx-translate/core'
import { NzMessageService } from 'ng-zorro-antd/message'
import { NzModalRef } from 'ng-zorro-antd/modal'
import { NzUploadFile } from 'ng-zorro-antd/upload'
import { Observable } from 'rxjs'
import { finalize } from 'rxjs/operators'

@Component({
  selector: 'vss-ui-import-file',
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss']
})
export class ImportFileComponent implements OnInit {
  progress = 0;
  isUploading = false;
  uploadFile: NzUploadFile | null = null;
  fileSize: any = 0;
  uploadResult: any
  disablePreview = false;
  data: any = {}
  @Input() isCheckBuiCongMinh: boolean = false
  @Input() sampleFileName: any = '';
  @Input() downloadSampleFilePr: () => any
  @Input() onPreviewPr: () => any
  @Input() handleFileUpload: (uploadFile: NzUploadFile) => Observable<ResponseModel<any>>
  @Input() onImportFile: (uploadFile: NzUploadFile) => Observable<ResponseModel<any>>
  @Input() errorFileName: any = 'File_result.xlsx'
  onlyImport = false
  unlimited = true
  team = null

  ngOnInit(): void {
  }

  constructor(
    private messageService: NzMessageService,
    private modalRef: NzModalRef,
    private translateService: TranslateService,
  ) { }

  handleUpload = (file: NzUploadFile, fileLst: NzUploadFile[]) => {
    this.uploadResult = null
    const isExcel = file.type === 'application/vnd.ms-excel' || // .xls
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
    if (!isExcel) {
      this.messageService.error(this.translateService.instant("FILE.INVALID_FORMAT"))
      this.disablePreview = true
      return false
    }
    if (file?.size)
      this.fileSize = (file?.size / (1024 * 1024)).toFixed(3)
    if (!this.unlimited && (this.fileSize > 25)) {
      this.messageService.error(this.translateService.instant("FILE.FILE_SIZE_EXCEEDED"))
      this.disablePreview = true
      return false
    }
    this.uploadFile = file
    this.disablePreview = false
    this.startUpload()

    this.handleFileUpload(file).pipe(
      finalize(() => {
        this.isUploading = false
      })
    ).subscribe(
      res => {
        this.uploadResult = res?.data
        // this.startUpload(!res?.data?.status)
        // this.startUpload(false) // tạm fix cứng sau mở lại dòng trên
      })
    return true
  }

  startUpload(): void {
    this.isUploading = true
    this.progress = 0
    const uploadInterval = setInterval(() => {

      if (this.isUploading) {
        if (this.progress < 95) this.progress += 5
      } else {
        this.progress = 100
        clearInterval(uploadInterval)
        this.isUploading = false

      }
    }, 200)
  }

  handleFile() {
  }

  customUpload = (item: any): any => {
  };

  onRemoveFile() {
    this.uploadFile = null
    this.uploadResult = null
    this.disablePreview = true
  }

  onCloseModal() {
    this.modalRef.close()
  }

  downloadSampleFile(): any {
    if (this.downloadSampleFilePr) this.downloadSampleFilePr()
  }

  onPreview() {
    if (this.onImport) {
      this.onImport()
      return
    }

    this.onPreviewPr().afterClose.subscribe((res: any) => {
      if (!res) return
      this.modalRef.close(true)
    })
  }

  isResponseJson = false
  onImport() {
    if (!this.uploadFile) return
    this.onImportFile(this.uploadFile).pipe(
      finalize(() => {

      })
    ).subscribe((res: any) => {
      if (res.code !== ResponseCode.SUCCESS) return
      const data = res?.data
      if (this.isResponseJson) {
        if (!data?.success && !data?.status) {
          this.uploadResult = data
          return
        }

        if (data?.status === true && !data?.fileError) {
          this.uploadResult = data
          this.modalRef.close(true)
          return
        } else if (data?.fileError) {
          this.uploadResult = data
          return
        }

      }
      this.modalRef.close(true)
    })
  }

  downloadResultFile() {
    this.downloadFilePublic(this.uploadResult?.data ? this.uploadResult?.data : this.uploadResult?.fileError, this.uploadResult?.fileName)
  }

  downloadFilePublic(file: any, filename: string): void {
    const byteCharacters = atob(file)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: 'application/octet-stream' })
    var link = document.createElement('a')
    document.body.appendChild(link)
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', filename)
    link.click()
    document.body.removeChild(link)
  }
}
